import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private toastr: ToastrService) {}

  public options = {
    debug: false,
    onclick: null,
    fadeIn: 300,
    fadeOut: 1000,
    timeOut: 3000,
    extendedTimeOut: 1000,
    closeButton: true,
  };

  info(message?: string, title?: string, override?: any) {
    this.toastr.info(message, title, { ...this.options, ...override });
  }

  warning(message?: string, title?: string, override?: any) {
    this.toastr.warning(message, title, { ...this.options, ...override });
  }

  success(message?: string, title?: string, override?: any) {
    this.toastr.success(message, title, { ...this.options, ...override });
  }

  error(message?: string, title?: string, override?: any) {
    this.toastr.error(message, title, { ...this.options, ...{ timeOut: 10000 }, ...override });
  }
}
